/**
 * Mobile Device Detection Utility
 */

/**
 * Detect Safari browser (has stricter autoplay policies like mobile)
 */
export function isSafariBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent.toLowerCase();
  // Safari but not Chrome (Chrome also contains 'safari' in UA)
  return ua.includes('safari') && !ua.includes('chrome') && !ua.includes('chromium');
}

/**
 * Detect if we're on a mobile device or Safari (both require user gesture for audio)
 */
export function isMobileDevice(): boolean {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent.toLowerCase();
  const isMobile = /iphone|ipad|ipod|android|mobile/.test(ua);

  // Treat Safari desktop like mobile - it has same autoplay restrictions
  return isMobile || isSafariBrowser();
}
